import {batchCommand, command, queryOne, querySearch, queryAll} from "../utils/api";

const GET_STOCK_TAKES_URL = `${process.env.PUBLIC_URL}/api/v1/r/stockTakes`;

export const SEARCH_STOCK_TAKES = 'SEARCH_STOCK_TAKES';
export const SEARCH_STOCK_TAKES_COMPLETED = 'SEARCH_STOCK_TAKES_COMPLETED';
export const SEARCH_STOCK_TAKES_FAILED = 'SEARCH_STOCK_TAKES_FAILED';
export const searchStockTakes = querySearch(GET_STOCK_TAKES_URL, SEARCH_STOCK_TAKES, SEARCH_STOCK_TAKES_COMPLETED, SEARCH_STOCK_TAKES_FAILED,
  ['description', 'startedAt'], {defaultOrder: 'startedAt DESC'});

const GET_STOCK_TAKE_DISCREPANCIES_URL = `${process.env.PUBLIC_URL}/api/v1/r/stockTakeDiscrepancies`;
export const SEARCH_STOCK_TAKE_DISCREPANCIES = 'SEARCH_STOCK_TAKE_DISCREPANCIES';
export const SEARCH_STOCK_TAKE_DISCREPANCIES_COMPLETED = 'SEARCH_STOCK_TAKE_DISCREPANCIES_COMPLETED';
export const SEARCH_STOCK_TAKE_DISCREPANCIES_FAILED = 'SEARCH_STOCK_TAKE_DISCREPANCIES_FAILED';
export const searchStockTakeDiscrepancies = querySearch(GET_STOCK_TAKE_DISCREPANCIES_URL, SEARCH_STOCK_TAKE_DISCREPANCIES,
  SEARCH_STOCK_TAKE_DISCREPANCIES_COMPLETED, SEARCH_STOCK_TAKE_DISCREPANCIES_FAILED, ['productDisplay', 'sku'],
  {defaultOrder: 'modifiedAt DESC'});

const GET_STOCK_TAKE_PRODUCTS = `${process.env.PUBLIC_URL}/api/v1/r/stockTakeProducts`;
export const SEARCH_STOCK_TAKE_PRODUCTS = 'SEARCH_STOCK_TAKE_PRODUCTS';
export const SEARCH_STOCK_TAKE_PRODUCTS_COMPLETED = 'SEARCH_STOCK_TAKE_PRODUCTS_COMPLETED';
export const SEARCH_STOCK_TAKE_PRODUCTS_FAILED = 'SEARCH_STOCK_TAKE_PRODUCTS_FAILED';
export const searchStockTakeProducts = querySearch(GET_STOCK_TAKE_PRODUCTS, SEARCH_STOCK_TAKE_PRODUCTS,
  SEARCH_STOCK_TAKE_PRODUCTS_COMPLETED, SEARCH_STOCK_TAKE_PRODUCTS_FAILED, ['productDisplay', 'sku']);

export const GET_STOCK_TAKE = 'GET_STOCK_TAKE';
export const GET_STOCK_TAKE_COMPLETED = 'GET_STOCK_TAKE_COMPLETED';
export const GET_STOCK_TAKE_FAILED = 'GET_STOCK_TAKE_FAILED';
export function getStockTake({stockTakeId}) {
  return queryOne(GET_STOCK_TAKES_URL, {where: {stockTakeId}}, GET_STOCK_TAKE, GET_STOCK_TAKE_COMPLETED, GET_STOCK_TAKE_FAILED);
}

const GET_STOCKS_URL = `${process.env.PUBLIC_URL}/api/v1/r/stocks`;
export const GET_STOCK_TAKE_STOCK = 'GET_STOCK_TAKE_STOCK';
export const GET_STOCK_TAKE_STOCK_COMPLETED = 'GET_STOCK_TAKE_STOCK_COMPLETED';
export const GET_STOCK_TAKE_STOCK_FAILED = 'GET_STOCK_TAKE_STOCK_FAILED';
export function getStock({salonId, sku}) {
  return queryOne(GET_STOCKS_URL, {where:{salonId, sku}}, GET_STOCK_TAKE_STOCK, GET_STOCK_TAKE_STOCK_COMPLETED, GET_STOCK_TAKE_STOCK_FAILED);
}

export const CLEAR_STOCK_TAKE_STOCK = 'CLEAR_STOCK_TAKE_STOCK';
export function clearStock() {
  return {type: CLEAR_STOCK_TAKE_STOCK};
}

const GET_STOCK_TAKE_COUNTS_URL = `${process.env.PUBLIC_URL}/api/v1/r/stockTakeCounts`;
export const GET_STOCK_TAKE_COUNTS = 'GET_STOCK_TAKE_COUNTS';
export const GET_STOCK_TAKE_COUNTS_COMPLETED = 'GET_STOCK_TAKE_COUNTS_COMPLETED';
export const GET_STOCK_TAKE_COUNTS_FAILED = 'GET_STOCK_TAKE_COUNTS_FAILED';
export function getStockTakeCounts({stockTakeId, sku}) {
  return queryAll(GET_STOCK_TAKE_COUNTS_URL, {where: {stockTakeId, sku}}, GET_STOCK_TAKE_COUNTS,
    GET_STOCK_TAKE_COUNTS_COMPLETED, GET_STOCK_TAKE_COUNTS_FAILED);
}

const GET_STOCK_TAKE_HISTORY_URL = `${process.env.PUBLIC_URL}/api/v1/r/stockTakeHistory`;
export const GET_STOCK_TAKE_HISTORY = 'GET_STOCK_TAKE_HISTORY';
export const GET_STOCK_TAKE_HISTORY_COMPLETED = 'GET_STOCK_TAKE_HISTORY_COMPLETED';
export const GET_STOCK_TAKE_HISTORY_FAILED = 'GET_STOCK_TAKE_HISTORY_FAILED';
export const searchStockTakeHistory = querySearch(GET_STOCK_TAKE_HISTORY_URL, GET_STOCK_TAKE_HISTORY,
  GET_STOCK_TAKE_HISTORY_COMPLETED, GET_STOCK_TAKE_HISTORY_FAILED, ['eventName', 'productDisplay', 'sku'],
  {defaultOrder: 'createdAt DESC'});

const STOCK_TAKE_ACTION_URL = `${process.env.PUBLIC_URL}/api/v1/stockTake`;
export const START_STOCK_TAKE = 'START_STOCK_TAKE';
export const START_STOCK_TAKE_COMPLETED = 'START_STOCK_TAKE_COMPLETED';
export const START_STOCK_TAKE_FAILED = 'START_STOCK_TAKE_FAILED';
export const startStockTake = command(STOCK_TAKE_ACTION_URL + '/start', START_STOCK_TAKE, START_STOCK_TAKE_COMPLETED, START_STOCK_TAKE_FAILED);

export const TAKE_STOCK_TAKE = 'TAKE_STOCK_TAKE';
export const TAKE_STOCK_TAKE_COMPLETED = 'TAKE_STOCK_TAKE_COMPLETED';
export const TAKE_STOCK_TAKE_FAILED = 'TAKE_STOCK_TAKE_FAILED';
export const takeStockTake = command(STOCK_TAKE_ACTION_URL + '/takeStock', TAKE_STOCK_TAKE, TAKE_STOCK_TAKE_COMPLETED, TAKE_STOCK_TAKE_FAILED);

export const END_STOCK_TAKE = 'END_STOCK_TAKE';
export const END_STOCK_TAKE_COMPLETED = 'END_STOCK_TAKE_COMPLETED';
export const END_STOCK_TAKE_FAILED = 'END_STOCK_TAKE_FAILED';
export const endStockTake = command(STOCK_TAKE_ACTION_URL + '/end', END_STOCK_TAKE, END_STOCK_TAKE_COMPLETED,
  END_STOCK_TAKE_FAILED);

const PRODUCT_ACTION_URL = `${process.env.PUBLIC_URL}/api/v1/product`;
export const ADJUST_STOCKS = 'ADJUST_STOCKS';
export const ADJUST_STOCK_COMPLETED = 'ADJUST_STOCK_COMPLETED';
export const ADJUST_STOCK_FAILED = 'ADJUST_STOCK_FAILED';
export const adjustStocks = batchCommand(PRODUCT_ACTION_URL + '/adjustProduct', ADJUST_STOCKS, ADJUST_STOCK_COMPLETED,
  ADJUST_STOCK_FAILED, ({productId, sku}) => productId + '`' + sku);



// WEBPACK FOOTER //
// ./src/StockTake/actions.js